export class CategoriaModel {
  _id:any;
  orden:number = 1;
  nombre:string = "";

}

export class SubcategoriaModel {
  _id:any;
  orden:number = 1;
  categoria:any = {};
  nombre:string = "";

  toJSON(){
    return {
      orden: this.orden,
      categoria:this.categoria._id,
      nombre: this.nombre,
    }
  }
}
